import type { EntityListParams } from './types'

/**
 * TanStack query keys for an entity: `all`, `list(params)`, `detail(id)`.
 *
 * Pass the entity's own params type (`EntityListParamsFor<XFilter>`) and it travels with
 * the keys into `createEntityQueries`, which is where `useList` — and through it every
 * table and select of this entity — picks the filter names up from.
 */
export function createEntityQueryKeys<
  TParams extends EntityListParams = EntityListParams
>(all: readonly [string]) {
  return {
    all,
    list: (params: TParams) => [...all, 'list', params] as const,
    detail: (id: string | number) => [...all, 'detail', id] as const
  }
}
